const Button = ({
  children,
  onClick,
  variant = "primary",
  type = "button",
}) => {
  const base =
    "px-4 py-2 rounded-lg font-medium transition text-sm leading-tight";

  const variants = {
    primary: "bg-[#95785A] text-white hover:opacity-90",
    danger: "bg-red-600 text-white hover:opacity-90",
    outline:
      "border border-gray-300 text-gray-700 hover:bg-gray-100",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${base} ${variants[variant]}`}
    >
      {children}
    </button>
  );
};

export default Button;